import { SelectOptionUi } from '@/components/Select/SelectUi';

export type AddSellerDialogUi = {
  businessName: string;
  businessNameError?: string;
  responsibleName: string;
  responsibleNameError?: string;
  rfc: string;
  rfcError?: string;
  fiscalRegimeOptions: SelectOptionUi[];
  fiscalRegime: string;
  fiscalRegimeError?: string;
  legalName: string;
  legalNameError?: string;
  phoneNumber: string;
  phoneNumberError?: string;
  purchaseMinAmount: string;
  purchaseMinAmountError?: string;
  email: string;
  emailError?: string;
  password: string;
  passwordError?: string;
  saveDisabled?: boolean;
};

export const initialState: AddSellerDialogUi = {
  businessName: '',
  responsibleName: '',
  rfc: '',
  fiscalRegimeOptions: [],
  fiscalRegime: '',
  legalName: '',
  phoneNumber: '',
  purchaseMinAmount: '',
  email: '',
  password: '',
};
